class CompareProducts {
  constructor() {
    this.storageKey = 'compareProducts';
    this.maxItems = 4; // adjust how many products can be compared at once
    this.init();
  }

  init() {
    this.bindEvents();
    this.syncButtonStates();
    this.renderBar();
  }

  getList() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch (e) {
      return [];
    }
  }

  saveList(list) {
    localStorage.setItem(this.storageKey, JSON.stringify(list));
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const toggleBtn = e.target.closest('[data-compare-toggle]');
      if (toggleBtn) {
        e.preventDefault();
        this.toggle(
          toggleBtn.dataset.compareHandle,
          toggleBtn.dataset.compareTitle,
          toggleBtn.dataset.compareImage
        );
        return;
      }

      const removeBtn = e.target.closest('[data-compare-remove]');
      if (removeBtn) {
        e.preventDefault();
        this.remove(removeBtn.dataset.compareRemove);
        return;
      }

      if (e.target.closest('[data-compare-clear]')) {
        e.preventDefault();
        this.clear();
      }
    });
  }

  toggle(handle, title, image) {
    if (!handle) return; // guard against clicks that aren't actually the compare button

    let list = this.getList();
    const exists = list.some((p) => p.handle === handle);

    if (exists) {
      list = list.filter((p) => p.handle !== handle);
    } else {
      if (list.length >= this.maxItems) {
        alert(`You can compare up to ${this.maxItems} products at a time.`);
        return;
      }
      list.push({ handle, title, image });
    }

    this.saveList(list);
    this.syncButtonStates();
    this.renderBar();
  }

  remove(handle) {
    const list = this.getList().filter((p) => p.handle !== handle);
    this.saveList(list);
    this.syncButtonStates();
    this.renderBar();
  }

  clear() {
    this.saveList([]);
    this.syncButtonStates();
    this.renderBar();
  }

  syncButtonStates() {
    const list = this.getList();
    const handles = new Set(list.map((p) => p.handle));
    document.querySelectorAll('[data-compare-toggle]').forEach((btn) => {
      btn.classList.toggle('is-active', handles.has(btn.dataset.compareHandle));
    });
  }

  renderBar() {
    const bar = document.getElementById('compare-bar');
    if (!bar) return;

    // Don't show the floating bar on the compare page itself — the full
    // table is already on screen there, so the bar is redundant.
    if (document.getElementById('compare-table-container')) {
      bar.classList.remove('is-visible');
      bar.innerHTML = '';
      return;
    }

    const list = this.getList();

    if (list.length === 0) {
      bar.classList.remove('is-visible');
      bar.innerHTML = '';
      return;
    }

    bar.classList.add('is-visible');
    bar.innerHTML = `
      <div class="compare-bar__inner">
        <div class="compare-bar__items">
          ${list
            .map(
              (p) => `
              <div class="compare-bar__item">
                <img src="${p.image}" alt="${p.title}" width="40" height="40" loading="lazy">
                <span class="compare-bar__item-title">${p.title}</span>
                <button type="button" data-compare-remove="${p.handle}" aria-label="Remove ${p.title} from comparison">&times;</button>
              </div>
            `
            )
            .join('')}
        </div>
        <div class="compare-bar__actions">
          <a href="/pages/compare-products?items=${list.map((p) => p.handle).join(',')}" class="button compare-bar__view">
            Compare (${list.length})
          </a>
          <button type="button" data-compare-clear class="compare-bar__clear">Clear all</button>
        </div>
      </div>
    `;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.compareProductsInstance) return; // already initialized elsewhere on the page
  window.compareProductsInstance = new CompareProducts();
});

// Back/forward navigation can restore the page from bfcache instead of
// reloading it, which means DOMContentLoaded never fires again and the bar
// shows stale data from before a remove/clear on another page. Re-sync here.
window.addEventListener('pageshow', (event) => {
  if (event.persisted && window.compareProductsInstance) {
    window.compareProductsInstance.syncButtonStates();
    window.compareProductsInstance.renderBar();
  }
});